export const GOOGLE_MEET_APP_ID = 3;
export const ZOOM_APP_ID = 4;
export const GOOGLE_CALENDAR_ID = 5;
export const OUTLOOK_CALENDAR_ID = 8;
export const MICROSOFT_TEAMS_ID = 9;
export const STRIPE_APP_ID = 10;
export const PAYPAL_APP_ID = 11;
